import { device } from "components/styles";
import React, { ReactNode } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { ReactComponent as DataRoomIcon } from "assets/common/navigationBar/icon_bottom_home.svg";
import { ReactComponent as MatchingIcon } from "assets/common/navigationBar/icon_bottom_hand.svg";
// import { ReactComponent as MembershipIcon } from "assets/common/navigationBar/icon_bottom_card.svg";
// import { ReactComponent as CommuniyIcon } from "assets/common/navigationBar/icon_bottom_community.svg";
import { ReactComponent as NewsIcon } from "assets/common/navigationBar/icon_bottom_news.svg";
import { ReactComponent as MypageIcon } from "assets/common/navigationBar/icon_bottom_my.svg";

const NAVIGATION_ITEM = [
  {
    title: "데이터 룸",
    path: "/data-room",
    icon: <DataRoomIcon />,
  },
  {
    title: "전문가찾기",
    path: "/matching",
    icon: <MatchingIcon />,
  },
  // {
  //   title: "나의 활동",
  //   path: "/activity",
  //   icon: <CommuniyIcon />,
  // },
  {
    title: "뉴스",
    path: "/news",
    icon: <NewsIcon />,
  },
  // {
  //   title: "맴버십/열람권",
  //   path: "/membership",
  //   icon: <MembershipIcon />,
  // },
  {
    title: "MY",
    path: "/mypage",
    icon: <MypageIcon />,
  },
];

const NavigationBar = () => {
  return (
    <NavigationBarContainer>
      {NAVIGATION_ITEM.map((e, idx) => (
        <NavigationItem key={idx} item={e} />
      ))}
    </NavigationBarContainer>
  );
};

export default NavigationBar;

interface NavigationItemProps {
  item: {
    title: string;
    path: string;
    icon: ReactNode;
  };
}

const NavigationItem = ({ item }: NavigationItemProps) => {
  const { title, path, icon } = item;
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <NavigationItemContainer
      $isActive={pathname.includes(path)}
      onClick={() => navigate(path)}
    >
      {icon}
      <div className="itemTitle">{title}</div>
    </NavigationItemContainer>
  );
};

const NavigationBarContainer = styled.div`
  display: none;

  @media all and (${device.mobile}) {
    display: flex;
    padding: 1.7rem 1.2rem 3rem;
    background: #fff;
    border-top: 1px solid #e6eaee;
    width: 100%;
    height: 9.3rem;
    position: fixed;
    bottom: 0;
    z-index: 100;
    box-sizing: border-box;
  }
`;

const NavigationItemContainer = styled.div<{ $isActive: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  flex-grow: 1;

  & > .itemTitle {
    color: ${({ $isActive }) => ($isActive ? "#1C1D1F" : "#848c98")};
    text-align: center;
    font-size: 1.1rem;
    font-weight: 400;
    line-height: 150%;
  }

  path {
    fill: ${({ $isActive }) => ($isActive ? "#1C1D1F" : "#848c98")};
  }
`;
